<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card diario-respostas-card">
        <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h4 class="card-title mb-0">
            <i class="feather icon-book-open me-3"></i>
            Respostas do Diário
          </h4>
          <button type="button" class="btn btn-outline-light btn-sm" (click)="atualizarDados()">
            <i class="feather icon-refresh-cw me-1"></i>
            Atualizar
          </button>
        </div>
        <div class="card-body">
          <div class="filters-section mb-3">
            <div class="diario-filters-grid">
              <div class="diario-filters-field">
                <label for="filtroPrograma" class="form-label small mb-1 text-muted">Programa</label>
                <select
                  id="filtroPrograma"
                  class="form-select form-select-sm filter-select w-100"
                  [(ngModel)]="idProgramaFiltro"
                  (ngModelChange)="onProgramaFiltroChange()"
                >
                  <option [ngValue]="null">Selecione um programa</option>
                  <option *ngFor="let p of programas" [ngValue]="p.id">
                    {{ p.nome }}
                  </option>
                </select>
              </div>
              <div class="diario-filters-field">
                <label for="filtroResponsavel" class="form-label small mb-1 text-muted">Responsável</label>
                <select
                  id="filtroResponsavel"
                  class="form-select form-select-sm filter-select w-100"
                  [(ngModel)]="idResponsavelFiltro"
                  [disabled]="idProgramaFiltro == null"
                  (ngModelChange)="onResponsavelFiltroChange()"
                >
                  <option [ngValue]="null">Todos deste programa</option>
                  <option *ngFor="let resp of responsaveis" [ngValue]="resp.id">
                    {{ resp.nome }}
                  </option>
                </select>
              </div>
              <div class="diario-filters-search">
                <label for="filtroBuscaDiario" class="form-label small mb-1 text-muted">Buscar</label>
                <div class="search-box">
                  <i class="feather icon-search"></i>
                  <input
                    id="filtroBuscaDiario"
                    type="text"
                    class="form-control w-100"
                    [(ngModel)]="searchText"
                    [disabled]="idProgramaFiltro == null"
                    (input)="onSearch()"
                    placeholder="Pesquisar no resultado..."
                  />
                </div>
              </div>
              <div class="diario-filters-badges">
                <span class="form-label small mb-1 text-muted d-block diario-filters-badges-label">Resultados</span>
                <div class="diario-filters-badges-inner">
                  <span class="badge bg-teal">{{ filtradas.length }} filtrados</span>
                  <span class="badge bg-secondary" *ngIf="linhas.length !== filtradas.length">
                    {{ linhas.length }} total
                  </span>
                </div>
              </div>
            </div>
            <p class="text-muted small mt-2 mb-0" *ngIf="idProgramaFiltro == null">
              Selecione um programa para carregar as respostas e listar os responsáveis que possuem respostas vinculadas a ele.
            </p>
            <p class="text-muted small mt-2 mb-0" *ngIf="linhas.length >= limiteCarregar">
              Carregados até {{ limiteCarregar }} registros (data crescente na API).
            </p>
            <p class="text-muted small mb-0 mt-1 scroll-hint">
              <i class="feather icon-move me-1"></i>
              Arraste na área da tabela (fora dos links) para rolar horizontalmente e ver todas as colunas.
            </p>
          </div>

          <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
            <div class="d-flex align-items-center gap-2">
              <label class="mb-0 small text-muted" for="pageSizeSel">Por página</label>
              <select
                id="pageSizeSel"
                class="form-select form-select-sm w-auto"
                [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeChange()"
              >
                <option *ngFor="let n of opcoesTamanhoPagina" [ngValue]="n">{{ n }}</option>
              </select>
            </div>
            <div class="small text-muted" *ngIf="filtradas.length">
              Mostrando {{ indiceInicio }}–{{ indiceFim }} de {{ filtradas.length }}
            </div>
          </div>

          <div
            class="diario-respostas-scroll"
            (mousedown)="onScrollDragStart($event, scrollHost)"
            #scrollHost
          >
            <div class="table-responsive-inner">
              <table class="table table-hover table-sm table-diario-wide">
                <thead class="table-light">
                  <tr>
                    <th class="col-path-first">Path</th>
                    <th class="col-texto">Texto escolhido</th>
                    <th class="col-texto">Opção escolhida</th>
                    <th class="col-texto">Alimento</th>
                    <th class="col-texto">Observação</th>
                    <th class="col-nome">Responsável</th>
                    <th class="col-nome">Criança</th>
                    <th class="col-sexo">Sexo</th>
                    <th class="col-texto">Atividade</th>
                    <th class="col-texto">Etapa</th>
                    <th class="col-data">Data cadastro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of linhasPagina">
                    <td class="cell-path text-truncate">
                      <a
                        *ngIf="r.path && (r.path.startsWith('http') || r.path.startsWith('/')); else pathText"
                        [href]="r.path"
                        target="_blank"
                        rel="noopener noreferrer"
                        [title]="r.path"
                        >Abrir</a
                      >
                      <ng-template #pathText>
                        <span [title]="r.path">{{ r.path || "-" }}</span>
                      </ng-template>
                    </td>
                    <td class="text-truncate" [title]="r.textoEscolhido">{{ r.textoEscolhido || "-" }}</td>
                    <td class="text-truncate" [title]="r.opcaoEscolhido">{{ r.opcaoEscolhido || "-" }}</td>
                    <td class="text-truncate" [title]="r.alimento">{{ r.alimento || "-" }}</td>
                    <td class="text-truncate" [title]="r.observacao">{{ r.observacao || "-" }}</td>
                    <td class="text-truncate" [title]="r.nomeResponsavel">
                      {{ r.nomeResponsavel || "-" }}
                    </td>
                    <td class="text-truncate" [title]="r.nomeCrianca">{{ r.nomeCrianca || "-" }}</td>
                    <td>{{ r.sexoCrianca || "-" }}</td>
                    <td class="text-truncate" [title]="r.tituloAtividadePrograma">
                      {{ r.tituloAtividadePrograma || "-" }}
                    </td>
                    <td class="text-truncate" [title]="r.tituloEtapaPrograma">
                      {{ r.tituloEtapaPrograma || "-" }}
                    </td>
                    <td class="text-nowrap">
                      <span *ngIf="r.dataCadastro; else semData">{{
                        r.dataCadastro | date: "dd/MM/yyyy HH:mm:ss"
                      }}</span>
                      <ng-template #semData>-</ng-template>
                    </td>
                  </tr>
                  <tr *ngIf="filtradas.length === 0">
                    <td colspan="11" class="text-center text-muted py-4">
                      Nenhuma resposta encontrada.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            class="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-3"
            *ngIf="filtradas.length > pageSize"
          >
            <ngb-pagination
              [collectionSize]="filtradas.length"
              [(page)]="page"
              [pageSize]="pageSize"
              [maxSize]="5"
              [rotate]="true"
              [boundaryLinks]="true"
              size="sm"
              (pageChange)="onPageChange()"
            ></ngb-pagination>
          </div>
          <div
            class="d-flex justify-content-center mt-2"
            *ngIf="filtradas.length > 0 && filtradas.length <= pageSize"
          >
            <span class="small text-muted">Página 1 de 1</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
